<template>
  <div class="woo-summary-table-wrapper">
    <v-img
      :src="this.checkpointImage"
      :lazy-src="this.checkpointImage"
      class="woo-404-hero"
      height="300"
    />
    <div class="woo-summary-table">
      <div class="woo-summary-table-section">
        <h1 class="woo-summary-table-section-header">You made it through:</h1>
        <h1 class="woo-summary-table-section-header">
          {{ section.display_name }}
        </h1>
        <div class="woo-summary-table-section-copy">
          Take a moment to pat yourself on the back for all the new skills you
          just learned!
        </div>
        <div class="woo-summary-table-section-content">
          <v-list flat>
            <v-list-item
              v-for="(step, $stepIndex) in section.steps"
              :key="$stepIndex"
              class="woo-summary-table-section-step"
            >
              <v-list-item-icon>
                <v-icon
                  class="woo-summary-table-section-step-icon"
                  :class="{ completed: isStepCompleted(step) }"
                  >{{ getStepIcon(step) }}</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content
                align="left"
                class="woo-summary-table-section-step-title"
              >
                {{ step.display_name }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
      <div class="woo-summary-table-section">
        <h1 class="woo-summary-table-section-header">What you'll learn next:</h1>
        <h1 class="woo-summary-table-section-header">
          {{ nextSection.display_name }}
        </h1>
        <div class="woo-summary-table-section-content">
          <v-list flat>
            <v-list-item
              v-for="(step, $stepIndex) in nextSection.steps"
              :key="$stepIndex"
              class="woo-summary-table-section-step"
            >
              <v-list-item-icon>
                <v-icon class="woo-summary-table-section-step-icon upcoming">
                  mdi-minus</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content
                align="left"
                class="woo-summary-table-section-step-title"
              >
                {{ step.display_name }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Db from '@/helpers/Db';
import HelperMethods from '@/helpers/HelperMethods';
export default {
  name: 'SummaryTable',
  data() {
    return {
      currentPanel: 0,
    };
  },
  props: {
    passive: {
      type: Boolean,
    },
  },
  computed: {
    tutorial() {
      return Db.getFullTutorialBySlug(this.$route.params.id);
    },
    checkpointImage() {
      return this.tutorial?.checkpoint_screens_image_url || require('@/assets/summary_banner.jpeg')
    },
    section() {
      return Db.findSectionById({
        tutorial: this.tutorial,
        sectionId: this.$route.query.g,
      })
    },
    nextSection() {
      return Db.findSectionWithOffsetFromId({
        tutorial: this.tutorial,
        sectionId: this.$route.query.g,
        offset: 1
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    getStepIcon(step) {
      if (HelperMethods.isStepCompleted(step)) {
        return 'mdi-check';
      } else if (step.videos || step.microsteps) {
        return 'mdi-play';
      } else {
        return 'mdi-text';
      }
    },
    playStep(step) {
      this.$router.push({
        query: { v: step.videos[0].id, s: step.id }
      }).catch();
    },
    isStepCompleted(step) {
      return HelperMethods.isStepCompleted(step);
    },
  },
};
</script>
<style lang="scss" scoped>
.woo {
  &-summary-table {
    padding: 1.5rem;
    &-section {
      &-header {
        //styleName: Title;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.75rem;
        letter-spacing: 0em;
        text-align: center;
      }
      &-copy {
        //styleName: Body 16;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.3125rem;
        letter-spacing: -0.02em;
        text-align: left;
        margin: 0.5rem auto;
      }
      &-content {
        margin: 0.5rem auto 1rem;
      }
      &-step {
        padding: 0 0 1rem 0 !important;
        min-height: 2.5rem;
        &-icon {
          width: 2.5rem;
          height: 2.5rem;
          background-color: #c4c4c4;
          color: #fff;
          border-radius: 0.25rem;
          font-size: 1.125rem !important;
          &.completed {
            background-color: #2cc1bc;
          }
          &.upcoming {
            background-color: #004d69;
          }
        }
        &-title {
          padding: 0 !important;
        }
      }
    }
  }
}
.v-item-section {
  z-index: 1;
}
.v-list-item__icon {
  margin: 0 1rem 0 0 !important;
}
.v-list--flat {
  padding: 0 !important;
}
</style>
<style lang="scss">
//Overrides
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>